export const filterGraphicsOptions = [
    { key: 1, text: "Mes actual", value: 1},
    { key: 0, text: "Mes anterior", value: 2 },
    { key: 3, text: "Semana actual", value: 3 },
    { key: 4, text: "Semana anterior", value: 4 },
    { key: 5, text: "Hoy", value: 5 },
  ];